import store from '../store/store';

export const authHeader = () => ({
    headers: { Authorization: `Bearer ${store.getState().auth.accessToken}` }
});
